<template>
    <div class="create-edit-quiz">
        <div class="create-edit-quiz__background">
            <img src="~@/assets/images/quiz-bgc.png" alt="kasanowa" />
        </div>
        <KLayoutWrapper>
            <template #default>
                <div>
                    <div class="create-edit-quiz__admin-title">{{ $t('quiz.quiz') }}</div>
                    <div class="create-edit-quiz__description">
                        <div>{{ $t('quiz.quizDescription1') }}</div>
                        <span>{{ $t('quiz.quizDescription2') }}</span>
                    </div>
                    <div>
                        <div class="create-edit-quiz__tab-slider-wrapper">
                            <v-tabs v-model="tab" :bg-color="primary800" show-arrows center-active>
                                <v-tab v-for="item in questions" :id="`question-${item.id}`" :value="`question-${item.id}`" :key="item.id">{{ item.title }}</v-tab>
                            </v-tabs>
                            <div class="create-edit-quiz__tab-main-btn-wrapper">
                                <KButton
                                    v-if="questions.length > 1"
                                    id="edit-questions-btn"
                                    :label="$t('quiz.delete')"
                                    :color="black"
                                    width="11"
                                    red
                                    height="11"
                                    uppercase
                                    type="submit"
                                    @click="openSettingsModal"
                                />
                                <KButton
                                    id="add-question-btn"
                                    :label="$t('quiz.add')"
                                    icon="arrowRight"
                                    :color="black"
                                    width="11"
                                    height="11"
                                    uppercase
                                    type="submit"
                                    @click="addQuestion"
                                />
                            </div>
                        </div>
                        <KProgressBar v-if="loadingDetails" indeterminate height="2" :color="primary400" />
                        <v-window v-model="tab">
                            <v-window-item v-for="item in questions" :value="`question-${item.id}`" :key="item.id">
                                <div v-if="item.id === QUIZ_MAIN_TAB">
                                    <div class="create-edit-quiz__main-details-wrapper">
                                        <div class="create-edit-quiz__item-wrapper create-edit-quiz__item-wrapper--first">
                                            <div class="create-edit-quiz__item create-edit-quiz__item--first kasanowa-bold">{{ $t('quiz.nameForm') }}</div>
                                            <div class="create-edit-quiz__item create-edit-quiz__item--second">
                                                <div v-if="!generalFrom.isTitleEditMode">{{ generalFrom.title }}</div>
                                                <KTextField
                                                    v-if="generalFrom.isTitleEditMode"
                                                    id="input-title"
                                                    v-model="generalFrom.title"
                                                    name="title"
                                                    label=""
                                                    hide-details
                                                    :placeholder="$t('quiz.nameForm')"
                                                />
                                            </div>
                                            <div v-if="!generalFrom.isTitleEditMode" class="create-edit-quiz__item create-edit-quiz__item--third">
                                                <div class="create-edit-quiz__item-icon kasanowa-hover" @click="handleItemEditMode('title')">
                                                    <KIcon icon="edit" width="18" height="18" />
                                                </div>
                                                <div class="create-edit-quiz__item-icon kasanowa-hover" @click="handleItemRemoveTitle('title')">
                                                    <KIcon icon="trash" width="18" height="18" />
                                                </div>
                                            </div>
                                            <div v-if="generalFrom.isTitleEditMode" class="create-edit-quiz__item create-edit-quiz__item--third">
                                                <div class="create-edit-quiz__item-icon kasanowa-hover" @click="handleItemAcceptChange('title')">
                                                    <KIcon icon="tick" width="20" height="20" />
                                                </div>
                                                <div class="create-edit-quiz__item-icon kasanowa-hover" @click="handleItemCancelChange('title')">
                                                    <KIcon icon="close" width="20" height="20" />
                                                </div>
                                            </div>
                                        </div>

                                        <div class="create-edit-quiz__item-wrapper">
                                            <div class="create-edit-quiz__item create-edit-quiz__item--first kasanowa-bold">{{ $t('quiz.leadForm') }}</div>
                                            <div class="create-edit-quiz__item create-edit-quiz__item--second create-edit-quiz__item--white">
                                                <div v-if="!generalFrom.isLeadEditMode">{{ generalFrom.lead }}</div>
                                                <KTextField
                                                    v-if="generalFrom.isLeadEditMode"
                                                    id="input-lead"
                                                    v-model="generalFrom.lead"
                                                    name="lead"
                                                    label=""
                                                    hide-details
                                                    :placeholder="$t('quiz.leadForm')"
                                                />
                                            </div>
                                            <div v-if="!generalFrom.isLeadEditMode" class="create-edit-quiz__item create-edit-quiz__item--third create-edit-quiz__item--white">
                                                <div class="create-edit-quiz__item-icon kasanowa-hover" @click="handleItemEditMode('lead')">
                                                    <KIcon icon="edit" width="18" height="18" :color="black" />
                                                </div>
                                                <div class="create-edit-quiz__item-icon kasanowa-hover" @click="handleItemRemoveTitle('lead')">
                                                    <KIcon icon="trash" width="18" height="18" :color="black" />
                                                </div>
                                            </div>
                                            <div v-if="generalFrom.isLeadEditMode" class="create-edit-quiz__item create-edit-quiz__item--third create-edit-quiz__item--white">
                                                <div class="create-edit-quiz__item-icon kasanowa-hover" @click="handleItemAcceptChange('lead')">
                                                    <KIcon icon="tick" width="20" height="20" :color="black" />
                                                </div>
                                                <div class="create-edit-quiz__item-icon kasanowa-hover" @click="handleItemCancelChange('lead')">
                                                    <KIcon icon="close" width="20" height="20" :color="black" />
                                                </div>
                                            </div>
                                        </div>

                                        <div class="create-edit-quiz__item-wrapper">
                                            <div class="create-edit-quiz__item create-edit-quiz__item--first kasanowa-bold">{{ $t('quiz.textForm') }}</div>
                                            <div class="create-edit-quiz__item create-edit-quiz__item--second create-edit-quiz__item--white">
                                                <div v-if="!generalFrom.isTextEditMode">{{ generalFrom.text }}</div>
                                                <KTextArea
                                                    v-if="generalFrom.isTextEditMode"
                                                    id="input-text"
                                                    v-model="generalFrom.text"
                                                    name="text"
                                                    label=""
                                                    hide-details
                                                    :placeholder="$t('quiz.textForm')"
                                                />
                                            </div>
                                            <div v-if="!generalFrom.isTextEditMode" class="create-edit-quiz__item create-edit-quiz__item--third create-edit-quiz__item--white">
                                                <div class="create-edit-quiz__item-icon kasanowa-hover" @click="handleItemEditMode('text')">
                                                    <KIcon icon="edit" width="18" height="18" :color="black" />
                                                </div>
                                                <div class="create-edit-quiz__item-icon kasanowa-hover" @click="handleItemRemoveTitle('text')">
                                                    <KIcon icon="trash" width="18" height="18" :color="black" />
                                                </div>
                                            </div>
                                            <div v-if="generalFrom.isTextEditMode" class="create-edit-quiz__item create-edit-quiz__item--third create-edit-quiz__item--white">
                                                <div class="create-edit-quiz__item-icon kasanowa-hover" @click="handleItemAcceptChange('text')">
                                                    <KIcon icon="tick" width="20" height="20" :color="black" />
                                                </div>
                                                <div class="create-edit-quiz__item-icon kasanowa-hover" @click="handleItemCancelChange('text')">
                                                    <KIcon icon="close" width="20" height="20" :color="black" />
                                                </div>
                                            </div>
                                        </div>

                                        <div class="create-edit-quiz__item-wrapper">
                                            <div class="create-edit-quiz__item create-edit-quiz__item--first kasanowa-bold">{{ $t('quiz.videoForm') }}</div>
                                            <div class="create-edit-quiz__item create-edit-quiz__item--second create-edit-quiz__item--white">
                                                <div v-if="!generalFrom.isVideoUrlEditMode">{{ generalFrom.videoUrl }}</div>
                                                <KTextField
                                                    v-if="generalFrom.isVideoUrlEditMode"
                                                    id="input-video-url"
                                                    v-model="generalFrom.videoUrl"
                                                    name="lead"
                                                    label=""
                                                    hide-details
                                                    :placeholder="$t('quiz.videoUrl')"
                                                />
                                            </div>
                                            <div v-if="!generalFrom.isVideoUrlEditMode" class="create-edit-quiz__item create-edit-quiz__item--third create-edit-quiz__item--white">
                                                <div class="create-edit-quiz__item-icon kasanowa-hover" @click="handleItemEditMode('video')">
                                                    <KIcon icon="edit" width="18" height="18" :color="black" />
                                                </div>
                                                <div class="create-edit-quiz__item-icon kasanowa-hover" @click="handleItemRemoveTitle('video')">
                                                    <KIcon icon="trash" width="18" height="18" :color="black" />
                                                </div>
                                            </div>
                                            <div v-if="generalFrom.isVideoUrlEditMode" class="create-edit-quiz__item create-edit-quiz__item--third create-edit-quiz__item--white">
                                                <div class="create-edit-quiz__item-icon kasanowa-hover" @click="handleItemAcceptChange('video')">
                                                    <KIcon icon="tick" width="20" height="20" :color="black" />
                                                </div>
                                                <div class="create-edit-quiz__item-icon kasanowa-hover" @click="handleItemCancelChange('video')">
                                                    <KIcon icon="close" width="20" height="20" :color="black" />
                                                </div>
                                            </div>
                                        </div>

                                        <div class="create-edit-quiz__item-wrapper">
                                            <div class="create-edit-quiz__item create-edit-quiz__item--first kasanowa-bold">{{ $t('quiz.imageForm') }}</div>
                                            <div class="create-edit-quiz__item create-edit-quiz__item--second create-edit-quiz__item--white">
                                                <div v-if="!generalFrom.isImageEditMode">{{ typeof generalFrom.image === 'object' && generalFrom.image?.name ? generalFrom.image.name : '' }}</div>
                                                <img v-if="!generalFrom.isImageEditMode && typeof generalFrom.image === 'string'" :src="generalFrom.image" alt="kasanowa-quiz-image" />
                                                <DragAndDropFile
                                                    v-if="generalFrom.isImageEditMode"
                                                    input-id="drop-image"
                                                    acceptance=".png,.jpg,.jpeg"
                                                    :on-files-change="onFilesChange"
                                                />
                                            </div>
                                            <div v-if="!generalFrom.isImageEditMode" class="create-edit-quiz__item create-edit-quiz__item--third create-edit-quiz__item--white">
                                                <div class="create-edit-quiz__item-icon kasanowa-hover" @click="handleItemEditMode('image')">
                                                    <KIcon icon="edit" width="18" height="18" :color="black" />
                                                </div>
                                                <div class="create-edit-quiz__item-icon kasanowa-hover" @click="handleItemRemoveTitle('image')">
                                                    <KIcon icon="trash" width="18" height="18" :color="black" />
                                                </div>
                                            </div>
                                            <div v-if="generalFrom.isImageEditMode" class="create-edit-quiz__item create-edit-quiz__item--third create-edit-quiz__item--white">
                                                <div class="create-edit-quiz__item-icon kasanowa-hover" @click="handleItemAcceptChange('image')">
                                                    <KIcon icon="tick" width="20" height="20" :color="black" />
                                                </div>
                                                <div class="create-edit-quiz__item-icon kasanowa-hover" @click="handleItemCancelChange('image')">
                                                    <KIcon icon="close" width="20" height="20" :color="black" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div v-if="router.currentRoute.value.params.id !== 'create'" class="create-edit-quiz__save-btn-wrapper">
                                        <KButton
                                            id="submit-btn"
                                            :label="$t('quiz.saveQuestions')"
                                            icon="arrowRight"
                                            :color="black"
                                            width="11"
                                            height="11"
                                            uppercase
                                            secondary
                                            type="submit"
                                            @click="onSubmit"
                                            :disabled="loading"
                                        />
                                    </div>
                                </div>

                                <div v-else>
                                    <div class="create-edit-quiz__main-details-wrapper">
                                        <div class="create-edit-quiz__item-wrapper">
                                            <div class="create-edit-quiz__item create-edit-quiz__item--first kasanowa-bold">{{ $t('quiz.questionForm') }}</div>
                                            <div class="create-edit-quiz__item create-edit-quiz__item--second create-edit-quiz__item--white">
                                                <div v-if="!item.isQuestionEditMode" v-html="item.question"></div>
                                                <KVueEditor
                                                    v-if="item.isQuestionEditMode"
                                                    :id="`question-quiz-${item.id}`"
                                                    v-model="item.question"
                                                    name="question"
                                                    :placeholder="$t('quiz.questionForm')"
                                                />
                                            </div>
                                            <div v-if="!item.isQuestionEditMode" class="create-edit-quiz__item create-edit-quiz__item--third create-edit-quiz__item--white">
                                                <div class="create-edit-quiz__item-icon kasanowa-hover" @click="handleItemEditMode('question', item)">
                                                    <KIcon icon="edit" width="18" height="18" :color="black" />
                                                </div>
                                                <div class="create-edit-quiz__item-icon kasanowa-hover" @click="handleItemRemoveTitle('question', item)">
                                                    <KIcon icon="trash" width="18" height="18" :color="black" />
                                                </div>
                                            </div>
                                            <div v-if="item.isQuestionEditMode" class="create-edit-quiz__item create-edit-quiz__item--third create-edit-quiz__item--white">
                                                <div class="create-edit-quiz__item-icon kasanowa-hover" @click="handleItemAcceptChange('question', item)">
                                                    <KIcon icon="tick" width="20" height="20" :color="black" />
                                                </div>
                                                <div class="create-edit-quiz__item-icon kasanowa-hover" @click="handleItemCancelChange('question', item)">
                                                    <KIcon icon="close" width="20" height="20" :color="black" />
                                                </div>
                                            </div>
                                        </div>

                                        <div class="create-edit-quiz__item-wrapper">
                                            <div class="create-edit-quiz__item create-edit-quiz__item--first kasanowa-bold">{{ $t('quiz.typeForm') }}</div>
                                            <div class="create-edit-quiz__item create-edit-quiz__item--full create-edit-quiz__item--white">
                                                <div>
                                                    <KCheckbox
                                                        id="type-open"
                                                        v-model="item.isOpenQuestion"
                                                        :label="$t('quiz.open')"
                                                        hide-details
                                                        @click="handleCheckboxClick(item, true)"
                                                    />
                                                    <KCheckbox
                                                        id="type-close"
                                                        v-model="item.isCloseQuestion"
                                                        :label="$t('quiz.closed')"
                                                        hide-details
                                                        @click="handleCheckboxClick(item, false)"
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div v-if="!item.isOpenQuestion" class="create-edit-quiz__item-wrapper">
                                            <div class="create-edit-quiz__item create-edit-quiz__item--first kasanowa-bold">{{ $t('quiz.answersForm') }}</div>
                                            <div class="create-edit-quiz__item create-edit-quiz__item--answers">
                                                <v-tabs v-model="answersTab" :bg-color="primary400" show-arrows center-active>
                                                    <v-tab v-for="answer in item.answers" :id="`answer-${answer.id}`" :value="`answer-${answer.id}`" :key="answer.id">{{ answer.title }}</v-tab>
                                                </v-tabs>
                                                <KButton
                                                    id="add-answer-btn"
                                                    :label="$t('quiz.addAnswer')"
                                                    icon="arrowRight"
                                                    :color="black"
                                                    width="11"
                                                    height="11"
                                                    uppercase
                                                    type="submit"
                                                    @click="addAnswer(item)"
                                                />
                                            </div>
                                        </div>

                                        <div v-if="!item.isOpenQuestion" class="create-edit-quiz__item-wrapper">
                                            <v-window v-model="answersTab">
                                                <v-window-item v-for="answer in item.answers" :id="`answer-${answer.id}`" :value="`answer-${answer.id}`" :key="answer.id">
                                                    <div class="create-edit-quiz__item-wrapper">
                                                        <div class="create-edit-quiz__item create-edit-quiz__item--label kasanowa-bold">{{ $t('quiz.labelForm') }}</div>
                                                        <div class="create-edit-quiz__item create-edit-quiz__item--correct kasanowa-bold">{{ $t('quiz.correctForm') }}</div>
                                                        <div class="create-edit-quiz__item create-edit-quiz__item--comment kasanowa-bold">{{ $t('quiz.commentForm') }}</div>
                                                        <div class="create-edit-quiz__item create-edit-quiz__item--actions kasanowa-bold"></div>
                                                    </div>

                                                    <div class="create-edit-quiz__item-wrapper">
                                                        <div class="create-edit-quiz__item create-edit-quiz__item--label create-edit-quiz__item--no-border">{{ generalFrom.title }}</div>
                                                        <div class="create-edit-quiz__item create-edit-quiz__item--correct create-edit-quiz__item--white create-edit-quiz__item--no-border">
                                                            <div class="create-edit-quiz__item-answer-checkbox-wrapper">
                                                                <KCheckbox
                                                                    id="correct-true"
                                                                    v-model="answer.isCorrectAnswer"
                                                                    :label="$t('quiz.correct')"
                                                                    hide-details
                                                                    @click="handleCorrectAnswerCheckboxClick(answer, true)"
                                                                />
                                                                <KCheckbox
                                                                    id="correct-false"
                                                                    v-model="answer.isIncorrectAnswer"
                                                                    :label="$t('quiz.incorrect')"
                                                                    hide-details
                                                                    @click="handleCorrectAnswerCheckboxClick(answer, false)"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div class="create-edit-quiz__item create-edit-quiz__item--comment create-edit-quiz__item--white create-edit-quiz__item--align-left create-edit-quiz__item--no-border">
                                                            <div v-if="!answer.isAnswerEditMode">{{ answer.answer }}</div>
                                                            <KTextArea
                                                                v-if="answer.isAnswerEditMode"
                                                                :id="`answer-quiz-${answer.id}`"
                                                                v-model="answer.answer"
                                                                name="answer"
                                                                label=""
                                                                hide-details
                                                                :placeholder="$t('quiz.answerForm')"
                                                            />
                                                        </div>
                                                        <div class="create-edit-quiz__item create-edit-quiz__item--actions create-edit-quiz__item--white create-edit-quiz__item--no-border">
                                                            <div v-if="!answer.isAnswerEditMode" class="create-edit-quiz__item create-edit-quiz__item--third create-edit-quiz__item--white">
                                                                <div class="create-edit-quiz__item-icon kasanowa-hover" @click="handleItemEditMode('answer', answer)">
                                                                    <KIcon icon="edit" width="18" height="18" :color="black" />
                                                                </div>
                                                                <div class="create-edit-quiz__item-icon kasanowa-hover" @click="handleItemRemoveTitle('answer', answer)">
                                                                    <KIcon icon="trash" width="18" height="18" :color="black" />
                                                                </div>
                                                            </div>
                                                            <div v-if="answer.isAnswerEditMode" class="create-edit-quiz__item create-edit-quiz__item--third create-edit-quiz__item--white">
                                                                <div class="create-edit-quiz__item-icon kasanowa-hover" @click="handleItemAcceptChange('answer', answer)">
                                                                    <KIcon icon="tick" width="20" height="20" :color="black" />
                                                                </div>
                                                                <div class="create-edit-quiz__item-icon kasanowa-hover" @click="handleItemCancelChange('answer', answer)">
                                                                    <KIcon icon="close" width="20" height="20" :color="black" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </v-window-item>
                                            </v-window>
                                        </div>
                                    </div>
                                    <div class="create-edit-quiz__save-btn-wrapper">
                                        <KButton
                                            id="submit-btn"
                                            :label="$t('quiz.saveQuestions')"
                                            icon="arrowRight"
                                            :color="black"
                                            width="11"
                                            height="11"
                                            uppercase
                                            secondary
                                            type="submit"
                                            @click="onSubmit"
                                            :disabled="loading"
                                        />
                                    </div>
                                </div>
                            </v-window-item>
                        </v-window>
                    </div>
                </div>
            </template>
        </KLayoutWrapper>

        <KDialog
            :is-open-dialog-action="isOpenSettingsDialog"
            :is-close-dialog-action="isCloseSettingsDialog"
            close-header-btn
            @close-dialog="closeDialogWhenNoTargetPressed"
        >
            <template v-slot:default>
                <div class="create-edit-quiz__settings-dialog-wrapper">
                    <div class="create-edit-quiz__settings-dialog-main-question" v-for="(question, index) in questions">
                        <div class="create-edit-quiz__settings-dialog-question">
                            <div class="create-edit-quiz__settings-dialog-question-text">{{ question.title }} <div v-if="index !== 0">-</div> <span v-html="question.question"></span></div>
                            <div class="create-edit-quiz__dialog-action-wrapper" v-if="question.id > 0">
                                <KTooltip without-btn>
                                    <template v-slot:title>
                                        <div class="kasanowa-hover" @click="removeQuestion(index)">
                                            <KIcon icon="trash" :color="black" />
                                        </div>
                                    </template>
                                    <template v-slot:content>
                                        <div>{{ $t('quiz.remove') }}</div>
                                    </template>
                                </KTooltip>
                            </div>
                        </div>
                        <div v-for="(answer, indexAnswer) in question.answers" class="create-edit-quiz__settings-dialog-answer">
                            <div>{{ answer.title }} - {{ answer.answer }}</div>
                            <div v-if="indexAnswer !== 0 || question.answers.length > 1" class="create-edit-quiz__dialog-action-wrapper">
                                <KTooltip without-btn>
                                    <template v-slot:title>
                                        <div class="kasanowa-hover" @click="removeAnswer(indexAnswer, question.answers)">
                                            <KIcon icon="trash" :color="black" />
                                        </div>
                                    </template>
                                    <template v-slot:content>
                                        <div>{{ $t('quiz.removeAnswer') }}</div>
                                    </template>
                                </KTooltip>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </KDialog>
    </div>
</template>

<script setup lang="ts">
import { ref, watch } from '@vue/runtime-core';
import router from '@/router';
import QuizApi from '@/api/v1/QuizApi';
import { toast } from 'vue3-toastify';
import variables from '@/assets/scss/modules/variables.module.scss';
import {
    navigateToWithErrorToast,
    navigateToWithSuccessToast
} from '@/hooks/NavigateHooks';
import {
    QUIZ_MAIN_TAB,
    QUIZ_OPEN_ANSWER_TEXT,
    QUIZ_TYPE_CLOSED,
    QUIZ_TYPE_OPEN
} from '@/hooks/QuizHooks';
import type {
    IQuizDetailsAnswersResponse,
    IQuizDetailsQuestionsResponse,
    IQuizGeneralForm,
    IQuizQuestionAnswerForm,
    IQuizQuestionForm
} from '@/models/QuizModel';
import KLayoutWrapper from '@/components/atoms/KLayoutWrapper.vue';
import KButton from '@/components/atoms/KButton.vue';
import KTextField from '@/components/atoms/KTextField.vue';
import KTextArea from '@/components/atoms/KTextArea.vue';
import KIcon from '@/components/atoms/KIcon.vue';
import DragAndDropFile from '@/components/molecules/DragAndDropFile.vue';
import KCheckbox from '@/components/atoms/KCheckbox.vue';
import KProgressBar from '@/components/atoms/KProgressBar.vue';
import KVueEditor from '@/components/atoms/KVueEditor.vue';
import KDialog from '@/components/atoms/KDialog.vue';
import KTooltip from '@/components/atoms/KTooltip.vue';

const { primary400, primary800, black } = variables;

const isEditMode = ref<boolean>(false);
if (router.currentRoute.value.params.id !== 'create') {
    isEditMode.value = true;
}

const tab = ref<number>(QUIZ_MAIN_TAB);
const questions = ref<IQuizQuestionForm[]>([
    {
        id: QUIZ_MAIN_TAB,
        title: t('quiz.main'),
        isQuestionEditMode: false,
        question: null,
        prevQuestion: null,
        answers: [],
        isOpenQuestion: false,
        isCloseQuestion: true,
    },
]);
const addQuestion = () => {
    if (
        generalFrom.value.title == null
        || generalFrom.value.title === ''
        || generalFrom.value.lead == null
        || generalFrom.value.lead === ''
        || generalFrom.value.text == null
        || generalFrom.value.text === ''
    ) {
        toast.error(t('quiz.toast.missingGeneralFields'));
        return;
    }
    questions.value.push(
        {
            id: questions.value.length,
            title: t('quiz.quest') + ` ${questions.value.length}`,
            isQuestionEditMode: true,
            question: null,
            prevQuestion: null,
            isOpenQuestion: false,
            isCloseQuestion: true,
            answers: [
                {
                    id: 0,
                    title: t('quiz.answ') + ` 1`,
                    isAnswerEditMode: true,
                    answer: null,
                    prevAnswer: null,
                    isOpenAnswer: false,
                    isCloseAnswer: true,
                    isCorrectAnswer: false,
                    isIncorrectAnswer: true,
                },
            ],
        },
    );
};

const generalFrom = ref<IQuizGeneralForm>({
    title: null,
    lead: null,
    text: null,
    videoUrl: null,
    image: null,
    prevTitle: null,
    prevLead: null,
    prevText: null,
    prevVideoUrl: null,
    prevImage: null,
    isTitleEditMode: !isEditMode.value,
    isLeadEditMode: !isEditMode.value,
    isTextEditMode: !isEditMode.value,
    isVideoUrlEditMode: !isEditMode.value,
    isImageEditMode: !isEditMode.value,
});
const handleItemEditMode = (slug: string, question?: IQuizQuestionForm | IQuizQuestionAnswerForm) => {
    switch (slug) {
        case 'title':
            generalFrom.value.isTitleEditMode = true;
            break;
        case 'lead':
            generalFrom.value.isLeadEditMode = true;
            break;
        case 'text':
            generalFrom.value.isTextEditMode = true;
            break;
        case 'video':
            generalFrom.value.isVideoUrlEditMode = true;
            break;
        case 'image':
            generalFrom.value.isImageEditMode = true;
            break;
        case 'question':
            question.isQuestionEditMode = true;
            break;
        case 'answer':
            question.isAnswerEditMode = true;
            break;
        default:
            generalFrom.value.isTitleEditMode = true;
    }
};
const handleItemAcceptChange = (slug: string, question?: IQuizQuestionForm | IQuizQuestionAnswerForm) => {
    switch (slug) {
        case 'title':
            generalFrom.value.isTitleEditMode = false;
            generalFrom.value.prevTitle = generalFrom.value.title;
            break;
        case 'lead':
            generalFrom.value.isLeadEditMode = false;
            generalFrom.value.prevLead = generalFrom.value.lead;
            break;
        case 'text':
            generalFrom.value.isTextEditMode = false;
            generalFrom.value.prevText = generalFrom.value.text;
            break;
        case 'video':
            generalFrom.value.isVideoUrlEditMode = false;
            generalFrom.value.prevVideoUrl = generalFrom.value.videoUrl;
            break;
        case 'image':
            generalFrom.value.isImageEditMode = false;
            generalFrom.value.prevImage = generalFrom.value.image;
            break;
        case 'question':
            question.isQuestionEditMode = false;
            question.prevQuestion = question.question;
            break;
        case 'answer':
            question.isAnswerEditMode = false;
            question.prevAnswer = question.answer;
            break;
        default:
            generalFrom.value.isTitleEditMode = false;
            generalFrom.value.prevTitle = generalFrom.value.title;
    }
};
const handleItemCancelChange = (slug: string, question?: IQuizQuestionForm | IQuizQuestionAnswerForm) => {
    switch (slug) {
        case 'title':
            generalFrom.value.isTitleEditMode = false;
            generalFrom.value.title = generalFrom.value.prevTitle;
            break;
        case 'lead':
            generalFrom.value.isLeadEditMode = false;
            generalFrom.value.lead = generalFrom.value.prevLead;
            break;
        case 'text':
            generalFrom.value.isTextEditMode = false;
            generalFrom.value.text = generalFrom.value.prevText;
            break;
        case 'video':
            generalFrom.value.isVideoUrlEditMode = false;
            generalFrom.value.videoUrl = generalFrom.value.prevVideoUrl;
            break;
        case 'image':
            generalFrom.value.isImageEditMode = false;
            generalFrom.value.image = generalFrom.value.prevImage;
            break;
        case 'question':
            question.isQuestionEditMode = false;
            question.question = question.prevQuestion;
            break;
        case 'answer':
            question.isAnswerEditMode = false;
            question.answer = question.prevAnswer;
            break;
        default:
            generalFrom.value.isTitleEditMode = false;
            generalFrom.value.title = generalFrom.value.prevTitle;
    }
};
const handleItemRemoveTitle = (slug: string, question?: IQuizQuestionForm | IQuizQuestionAnswerForm) => {
    switch (slug) {
        case 'title':
            generalFrom.value.title = null;
            generalFrom.value.prevTitle = null;
            break;
        case 'lead':
            generalFrom.value.lead = null;
            generalFrom.value.prevLead = null;
            break;
        case 'text':
            generalFrom.value.text = null;
            generalFrom.value.prevText = null;
            break;
        case 'video':
            generalFrom.value.videoUrl = null;
            generalFrom.value.prevVideoUrl = null;
            break;
        case 'image':
            generalFrom.value.image = null;
            generalFrom.value.prevImage = null;
            break;
        case 'question':
            question.question = null;
            question.prevQuestion = null;
            break;
        case 'answer':
            question.answer = null;
            question.prevAnswer = null;
            break;
        default:
            generalFrom.value.title = null;
            generalFrom.value.prevTitle = null;
    }
};
const onFilesChange = (files: File[]) => {
    if (null != files && files.length > 0) {
        generalFrom.value.image = files[0];
    } else {
        generalFrom.value.image = null;
    }
};

const answersTab = ref<number>(0);
const addAnswer = (item: IQuizQuestionForm) => {
    item.answers.push({
        id: item.answers.length,
        title: t('quiz.answ') + ` ${item.answers.length + 1}`,
        isAnswerEditMode: true,
        answer: null,
        prevAnswer: null,
        isOpenAnswer: false,
        isCloseAnswer: true,
        isCorrectAnswer: false,
        isIncorrectAnswer: true,
    });
};
const handleCheckboxClick = (question: IQuizQuestionForm, isOpenAnswerClick: boolean) => {
    setTimeout(() => {
        if (isOpenAnswerClick) {
            question.isOpenQuestion = true;
            question.isCloseQuestion = false;
            question.answers = [
                {
                    id: 1,
                    title: t('quiz.answ') + '1',
                    isAnswerEditMode: false,
                    answer: QUIZ_OPEN_ANSWER_TEXT,
                    prevAnswer: QUIZ_OPEN_ANSWER_TEXT,
                    isOpenAnswer: true,
                    isCloseAnswer: false,
                    isCorrectAnswer: true,
                    isIncorrectAnswer: false,
                },
            ];
        }
        if (!isOpenAnswerClick) {
            question.isOpenQuestion = false;
            question.isCloseQuestion = true;
        }
    }, 1);
};
const handleCorrectAnswerCheckboxClick = (answer: IQuizQuestionAnswerForm, isCorrectAnswerClick: boolean | null) => {
    setTimeout(() => {
        if (null != isCorrectAnswerClick && isCorrectAnswerClick) {
            answer.isCorrectAnswer = true;
            answer.isIncorrectAnswer = false;
        }
        if (null != isCorrectAnswerClick && !isCorrectAnswerClick) {
            answer.isCorrectAnswer = false;
            answer.isIncorrectAnswer = true;
        }
        if (null == isCorrectAnswerClick) {
            answer.isCorrectAnswer = false;
            answer.isIncorrectAnswer = false;
        }
    }, 1);
};

const loading = ref<boolean>(false);
const quizApi = new QuizApi();
const onSubmit = async() => {
    if (
        generalFrom.value.title == null
        || generalFrom.value.title === ''
        || generalFrom.value.lead == null
        || generalFrom.value.lead === ''
        || generalFrom.value.text == null
        || generalFrom.value.text === ''
    ) {
        tab.value = QUIZ_MAIN_TAB;
        toast.error(t('quiz.toast.missingGeneralFields'));
        return;
    }
    let isValidError: boolean = false;
    let isValidAnswerError: boolean = false;
    questions.value.forEach((question: IQuizQuestionForm) => {
        if (
            (question.question == null || question.question === '')
            && question.title !== 'Ogólne'
            && !isValidError
        ) {
            tab.value = questions.value.indexOf(question);
            toast.error(t('quiz.toast.questionRequired'));
            isValidError = true;
            return;
        }
        if (!isValidError) {
            question.answers.forEach((answer: IQuizQuestionAnswerForm) => {
                if (
                    (answer.answer == null || answer.answer === '')
                    && !isValidAnswerError
                ) {
                    tab.value = questions.value.indexOf(question);
                    answersTab.value = question.answers.indexOf(answer);
                    isValidAnswerError = true;
                    toast.error(t('quiz.toast.answerRequired'));
                    return;
                }
            });
        }
    });
    if (isValidError || isValidAnswerError) {
        return;
    }
    loading.value = true;
    if (!isEditMode.value) {
        try {
            const result = await quizApi.createQuiz({
                name: generalFrom.value.title,
                lead: generalFrom.value.lead,
                text: generalFrom.value.text,
                video_url: generalFrom.value.videoUrl,
                image: generalFrom.value.image,
                questions: questions.value.slice(1).map((elem: IQuizQuestionForm) => {
                    return {
                        questionText: elem.question,
                        type: elem.isOpenQuestion ? QUIZ_TYPE_OPEN : QUIZ_TYPE_CLOSED,
                        points: 10,
                        answers: elem.answers.map((elems: IQuizQuestionAnswerForm) => {
                            return {
                                answerText: elems.answer,
                                isCorrect: elems.isCorrectAnswer,
                            };
                        }),
                    };
                }),
            });
            if (!result.isSuccess) {
                toast.error(t('quiz.toast.errorCreateQuiz'));
                loading.value = false;
                return;
            }
            navigateToWithSuccessToast(`/quiz/${result.payload.quiz_id}/summary`, t('quiz.toast.successCreateQuiz'));
        } catch (e) {
            toast.error(t('quiz.toast.errorCreateQuiz'));
            loading.value = false;
            return;
        }
    } else {
        try {
            const result = await quizApi.editQuiz(
                {
                    name: generalFrom.value.title,
                    lead: generalFrom.value.lead,
                    text: generalFrom.value.text,
                    video_url: generalFrom.value.videoUrl,
                    image: generalFrom.value.image,
                    questions: questions.value.slice(1).map((elem: IQuizQuestionForm) => {
                        return {
                            questionText: elem.question,
                            type: elem.isOpenQuestion ? QUIZ_TYPE_OPEN : QUIZ_TYPE_CLOSED,
                            points: 10,
                            answers: elem.answers.map((elems: IQuizQuestionAnswerForm) => {
                                return {
                                    answerText: elems.answer,
                                    isCorrect: elems.isCorrectAnswer,
                                };
                            }),
                        };
                    }),
                },
                router.currentRoute.value.params.id,
            );
            if (!result.isSuccess) {
                toast.error(t('quiz.toast.errorEditQuiz'));
                loading.value = false;
                return;
            }
            navigateToWithSuccessToast(`/quiz/${router.currentRoute.value.params.id}/summary`, t('quiz.toast.successEditQuiz'));
        } catch (e) {
            toast.error(t('quiz.toast.errorEditQuiz'));
            loading.value = false;
            return;
        }
    }
    loading.value = false;
};

const loadingDetails = ref<boolean>(false);
const quizDetails = async() => {
    loadingDetails.value = true;
    try {
        const result = await quizApi.quizDetails(router.currentRoute.value.params.id);
        if (!result.isSuccess) {
            navigateToWithErrorToast('/quiz', t('quiz.toast.errorQuizDetails'))
            loadingDetails.value = false;
            return;
        }
        generalFrom.value = {
            title: result.payload.name,
            lead: result.payload.lead,
            text: result.payload.text,
            videoUrl: result.payload.video_url,
            image: result.payload.image,
            prevTitle: result.payload.name,
            prevLead: result.payload.lead,
            prevText: result.payload.text,
            prevVideoUrl: result.payload.video_url,
            prevImage: result.payload.image,
            isTitleEditMode: false,
            isLeadEditMode: false,
            isTextEditMode: false,
            isVideoUrlEditMode: false,
            isImageEditMode: false,
        };
        const restOfQuestions = result.payload.questions.map((elem: IQuizDetailsQuestionsResponse) => {
            return {
                id: elem.id,
                title: t('quiz.quest') + ` ${result.payload.questions.indexOf(elem) + 1}`,
                isQuestionEditMode: false,
                question: elem.question_text,
                prevQuestion: elem.question_text,
                isOpenQuestion: elem.type === QUIZ_TYPE_OPEN ? true : false,
                isCloseQuestion: elem.type === QUIZ_TYPE_CLOSED ? true : false,
                answers: elem.answers.map((elems: IQuizDetailsAnswersResponse) => {
                    return {
                        id: elems.id,
                        title: t('quiz.answ') + ` ${elem.answers.indexOf(elems) + 1}`,
                        isAnswerEditMode: false,
                        answer: elems.answer_text,
                        prevAnswer: elems.answer_text,
                        isOpenAnswer: elem.type === QUIZ_TYPE_OPEN ? true : false,
                        isCloseAnswer: elem.type === QUIZ_TYPE_CLOSED ? true : false,
                        isCorrectAnswer: elems.is_correct != null && (elems.is_correct || elems.is_correct === 1) ? true : false,
                        isIncorrectAnswer: elems.is_correct != null && (!elems.is_correct || elems.is_correct === 0) ? true : false,
                    };
                }),
            };
        });
        // Jezeli nie zrobie ...restOfQuestions tylko samo restOfQuestions to doda sie osobna arrayka w arrayce
        questions.value.push(...restOfQuestions);
    } catch (e) {
        navigateToWithErrorToast('/quiz', t('quiz.toast.errorQuizDetails'))
        loadingDetails.value = false;
        return;
    }
    loadingDetails.value = false;
};
if (isEditMode.value) {
    quizDetails();
}

const isOpenSettingsDialog = ref<boolean>(false);
const isCloseSettingsDialog = ref<boolean>(true);
const closeDialogWhenNoTargetPressed = () => {
    questions.value.forEach((elem: IQuizQuestionForm) => {
        if (elem.id !== QUIZ_MAIN_TAB) {
            elem.title = t('quiz.quest') + ` ${questions.value.indexOf(elem)}`;
        }
        elem.answers.forEach((elems: IQuizQuestionAnswerForm) => {
            elems.title = t('quiz.answ') + ` ${elem.answers.indexOf(elems) + 1}`;
        });
    });
    isOpenSettingsDialog.value = false;
    isCloseSettingsDialog.value = true;
};
const openSettingsModal = () => {
    isOpenSettingsDialog.value = true;
    isCloseSettingsDialog.value = false;
};
const removeQuestion = (questionIndex: number) => {
    questions.value.splice(questionIndex, 1);
    if (questions.value.length === 1) {
        closeDialogWhenNoTargetPressed();
    }
    tab.value = QUIZ_MAIN_TAB;
};
const removeAnswer = (answerIndex: number, questionAnswers: IQuizQuestionAnswerForm[]) => {
    questionAnswers.splice(answerIndex, 1);
    answersTab.value = 0;
};

watch(() => tab.value, (newValue, oldValue) => {
    if (newValue !== oldValue) {
        answersTab.value = 0;
    }
},{
    deep: true,
});
</script>

<style scoped lang="scss">
.create-edit-quiz {
    width: 100%;
    position: relative;

    &__background {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 0;
        width: 100%;
        height: 100%;

        img {
            object-fit: cover;
            width: 100%;
            height: calc(100% - 184px);
            min-height: calc(100vh - 184px);

            @include media-breakpoint-up(lg) {
                height: calc(100% - 217px);
                min-height: calc(100vh - 217px);
            }
        }
    }

    &__admin-title {
        background-color: $primary-400;
        color: $black;
        font-weight: 1000;
        padding: 8px;
        text-transform: uppercase;
        font-size: 20px;
        text-align: center;
        max-width: 520px;
        margin: 0 auto;

        @include media-breakpoint-up(lg) {
            font-size: 40px;
            padding: 18px 24px;
            max-width: 680px;
        }
    }

    &__description {
        margin-top: 17px;
        display: flex;
        flex-wrap: wrap;
        gap: 5px;
        justify-content: center;
        color: $white;
        font-size: 18px;

        span {
            font-weight: 700;
            color: $primary-400;
        }
    }

    &__tab-slider-wrapper {
        display: flex;
        gap: 10px;
        flex-direction: column;

        @include media-breakpoint-up(lg) {
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
        }

        &:deep(.v-tab--selected) {
            background-color: $primary-400;
            color: $black;
        }

        &:deep(.v-tab--selected .v-tab__slider) {
            background-color: transparent;
        }
    }

    &__main-details-wrapper {
        display: flex;
        flex-direction: column;
        overflow-x: scroll;
    }

    &__item-wrapper {
        display: flex;
        width: 1272px;

        &--first {
            border-bottom: 3px solid $secondary-400;
        }
    }

    &__item {
        color: $white;
        padding: 15px 0;
        display: flex;
        background-color: $primary-800;

        &--first {
            padding-left: 20px;
            width: 20%;
            min-width: 220px;
            max-width: 220px;
        }

        &--second {
            width: 70%;
            min-width: 925px;
            padding: 15px 20px;
        }

        &--third {
            width: 10%;
            min-width: 120px;
            padding: 5px 0;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 25px;
        }

        &--full {
            width: 83%;
            padding: 15px 20px;
        }

        &--white {
            background-color: $white;
            color: $black;
        }

        &--answers {
            width: 90%;
            justify-content: space-between;
            align-items: center;
            background-color: transparent;
            padding: 0;

            &:deep(.v-tab.v-tab.v-btn) {
                background-color: $primary-800;
                color: $white;
            }

            &:deep(.v-tab--selected) {
                background-color: $primary-400 !important;
                color: $black !important;
            }

            &:deep(.v-tab--selected .v-tab__slider) {
                background-color: transparent;
            }
        }

        &--label {
            padding-left: 20px;
            width: 20%;
            min-width: 220px;
            border-bottom: 3px solid $secondary-400;
        }

        &--correct {
            width: 10%;
            min-width: 120px;
            border-bottom: 3px solid $secondary-400;
            display: flex;
            justify-content: center;
        }

        &--comment {
            width: 50%;
            min-width: 632px;
            border-bottom: 3px solid $secondary-400;
            display: flex;
            justify-content: center;
        }

        &--actions {
            width: 20%;
            min-width: 150px;
            border-bottom: 3px solid $secondary-400;
            display: flex;
            justify-content: center;
        }

        &--align-left {
            justify-content: flex-start;
            padding-left: 10px;
        }

        &--no-border {
            border: none;
        }

        &:deep(.k-input) {
            background-color: $white;
            border-radius: 8px;
        }

        &:deep(.k-vue-editor) {
            width: 100%;
            margin-bottom: 50px;
        }

        &:deep(.k-vue-editor__errors) {
            display: none;
        }

        &:deep(.k-text-area) {
            background-color: $white;
            border-radius: 5px;
            width: 100%;
            border: 1px solid $grey-400;
        }

        &:deep(.drag-and-drop-file) {
            width: 100%;
        }
    }

    &__item-icon {
        padding: 5px 4px;
        height: 28px;
    }

    &__item-answer-checkbox-wrapper {
        display: flex;
        flex-direction: column;
    }

    &__save-btn-wrapper {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        margin-top: 10px;
    }

    #question-0 {
        width: 220px;
    }

    #add-question-btn {
        margin-bottom: 10px;

        @include media-breakpoint-up(lg) {
            margin-bottom: 0;
        }
    }

    &__tab-main-btn-wrapper {
        display: flex;
        flex-direction: column;
        gap: 10px;

        @include media-breakpoint-up(lg) {
            flex-direction: row;
        }
    }

    &__settings-dialog-wrapper {
        display: flex;
        flex-direction: column;
        gap: 5px;
        padding: 10px;
        border-radius: 8px;
        margin-right: 20px;
        background-color: $white;
    }

    &__settings-dialog-main-question {
        display: flex;
        flex-direction: column;
        gap: 3px;
    }

    &__settings-dialog-question {
        display: flex;
        align-items: center;
        padding: 10px;
        border: 1px solid $black;
        border-radius: 8px;
        transition: background-color 0.3s;

        &:hover {
            background-color: $secondary-400;
        }

        &:deep(.k-tooltip) {
            height: 16px;
        }
    }

    &__dialog-action-wrapper {
        margin-left: auto;
    }

    &__settings-dialog-question-text {
        display: flex;
        gap: 3px;

        span {
            width: 70px;
            height: 20px;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            line-clamp: 1;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;

            @include media-breakpoint-up(sm) {
                width: 280px;
            }
        }
    }

    &__settings-dialog-answer {
        display: flex;
        align-items: center;
        padding: 10px;
        border: 1px solid rgba($black, 0.3);
        margin-left: 15px;
        border-radius: 8px;
        transition: background-color 0.3s;

        &:hover {
            background-color: $secondary-400;
        }

        &:deep(.k-tooltip) {
            height: 16px;
        }
    }
}
</style>
